module.exports = __webpack_public_path__ + "img/icon-tit_counter.0747ca10.png";